import { useState, useRef, useEffect } from "react";
import {Image, Header, Placeholder, Button, Divider} from "semantic-ui-react";
import Arrow from '../assets/images/right-arrow.png';

export default function CompetitionsCards(props) {
    const imgRef = useRef(null);
    const [state, setState] = useState(false);

    const onImageLoaded = () => setState(true);

    useEffect(() => {
        const imgElCurrent = imgRef.current;

        if (imgElCurrent) {
            imgElCurrent.addEventListener("load", onImageLoaded);
            return () => imgElCurrent.removeEventListener("load", onImageLoaded);
        }
    }, [imgRef]);

    const { name, photo, details, rules, submit, setShow, setContent, modal , btnVisibilty,  } = props;
    return (
        <div  className={"proshows-details-card"}>

            <div className={'img-section'}>
                <Placeholder className={"proshows-photo"} style={{ display: state ? "none" : "block" }}>
                    {/*<Placeholder.Image*/}
                    {/*    as={"img"}*/}
                    {/*    style={{ display: state ? "none" : "block" }}*/}
                    {/*    */}
                    {/*/>*/}
                </Placeholder>

                <Image
                    onLoad={onImageLoaded}
                    src={photo}

                    className={"proshows-photo"}
                    style={{ display: state ? "block" : "none" }}
                />
            </div>
            <div className={"proshows-detail-section"}>
                <Header className={"proshows-name"} as={"h3"}>
                    {name}
                </Header>
                <Divider className={'divider'}/>
                {/*<p className={'number'}>{number}</p>*/}
                <p className={"proshows-details"}>{details}</p>

                {
                    submit && (
                        <a  target={'_blank'} href={'https://forms.gle/MbYYoGoJpbJdngcs6'}>
                            <img src={Arrow} className={'right-arrow'}/>
                        </a>
                    )
                }
                {/*<div style={{textAlign:'center'}}>*/}
                {/*    /!*<a href={rules} target={"_blank"}>*!/*/}
                {/*    {btnVisibilty && (!btnVisibilty[0]) ? null : (*/}
                {/*        <><Button onClick={()=>{*/}
                {/*            setContent(modal);*/}
                {/*            setShow(true);*/}
                {/*        }} className='rulesButton'>*/}
                {/*            LEARN MORE*/}
                {/*        </Button>*/}
                {/*            <br/></>*/}
                {/*    )}*/}
                {/*    /!*</a>*!/*/}
                {/*    {*/}
                {/*        btnVisibilty && ( !btnVisibilty[1]) ? null : (*/}
                {/*            <a style={{display: submit ? "block" : "none"}} href={submit} target={"_blank"}>*/}
                {/*                <Button className='rulesButton'>*/}
                {/*                    SUBMIT*/}
                {/*                </Button>*/}
                {/*            </a>*/}
                {/*        )*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
        </div>
    );
}
